import React from "react";
import "../../pages/style.css";
import { Container, Row, Col } from "react-bootstrap";
import Text from "../Homepage/Text";
import { AiFillInstagram, AiFillFacebook, AiFillYoutube } from "react-icons/ai";

function Home() {
  return (
    <div className="homepagebackground">
      <Container>
        <Row>
          <Col md={7}>
            <h2 className="headtext">
              Hello <span className="wave">👋 </span>
            </h2>
            <h2 className="nametext">I'm Phan Lê Trân Châu (Chloe Phan)</h2>
            <span></span>
            <Text />
            <button
              onClick={() => {
                window.open("https://www.facebook.com/tran.chau.178/");
              }}
              className="socailmediabtn"
            >
              <AiFillFacebook className="icon" />
            </button>
            <button
              onClick={() => {
                window.open(
                  "https://www.youtube.com/channel/UC94Jyp30IvEAC43yD3mbSKw"
                );
              }}
              className="socailmediabtn"
            >
              <AiFillYoutube className="icon" />
            </button>
            <button
              onClick={() => {
                window.open("https://www.instagram.com/ch_l1485/");
              }}
              className="socailmediabtn"
            >
              <AiFillInstagram className="icon" />
            </button>
          </Col>

          <Col md={5}>
            <div className="imagedeveloper"></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;
